import { SiteEmployee as SiteEmployeeInterface } from "../../../../models/employee.interface";

interface SiteEmployeeProps {
  employee: SiteEmployeeInterface;
}

function SiteEmployee({ employee }: SiteEmployeeProps) {
  return (
    <div style={{ padding: "20px" }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
        <div>
          <label
            style={{ display: "block", fontSize: "14px", fontWeight: 500, marginBottom: "8px" }}
          >
            Name
          </label>
          <div style={{ fontSize: "16px" }}>{employee.name || "-"}</div>
        </div>

        <div>
          <label
            style={{ display: "block", fontSize: "14px", fontWeight: 500, marginBottom: "8px" }}
          >
            Surname
          </label>
          <div style={{ fontSize: "16px" }}>{employee.surname || "-"}</div>
        </div>

        <div>
          <label
            style={{ display: "block", fontSize: "14px", fontWeight: 500, marginBottom: "8px" }}
          >
            Email
          </label>
          <div style={{ fontSize: "16px" }}>{employee.email || "-"}</div>
        </div>

        <div>
          <label
            style={{ display: "block", fontSize: "14px", fontWeight: 500, marginBottom: "8px" }}
          >
            Mobile
          </label>
          <div style={{ fontSize: "16px" }}>{employee.mobile || "-"}</div>
        </div>

        <div>
          <label
            style={{ display: "block", fontSize: "14px", fontWeight: 500, marginBottom: "8px" }}
          >
            Department
          </label>
          <div style={{ fontSize: "16px" }}>{employee.department || "-"}</div>
        </div>
      </div>
    </div>
  );
}

export { SiteEmployee };
